import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {AppState} from '../store/core.state';
import {authRedirect} from '../store/auth/auth.actions';
import {AUTH_ACCESS_TOKEN, AUTH_ROLE_ID} from '../models';
import { LocalStorageService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private store: Store<AppState>, private localStorageService: LocalStorageService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const rolId = this.localStorageService.getItem(AUTH_ROLE_ID);
    const accessToken = this.localStorageService.getItem(AUTH_ACCESS_TOKEN);

    return this.store.pipe(
      map(() => {
        let result = true;
        if (accessToken) {
          if (!rolId) {
            this.store.dispatch(authRedirect({url: '/features/put-role'}));
            result = false;
          }
        } else {
          result = false;
        }
        return result;
      })
    );
  }
}
